<template>
  <div class="social-view">
    <div class="con-sal">
        <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
    </div>
    <SocialDashboard />
  </div>
</template>

<script>
import SocialDashboard from '@/components/social/SocialDashboard.vue'

export default {
  name: 'Social',
  components: {
    SocialDashboard
  },
    methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
  }
}
</script>

<style scoped>
.social-view {
    height: 100vh;
    display: flex;
    flex-direction: column;
}
</style>
